// extracted by mini-css-extract-plugin
module.exports = {"innerShadow":"sideBar_innerShadow__Z7_qE","customScrollBar":"sideBar_customScrollBar__LZBRC","sidebarTransition":"sideBar_sidebarTransition__Mgi6T"};